<script setup>
import router from '../../routes/index';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  iconOnly: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    type="button"
    class="flex cursor-pointer items-center font-normal text-n-slate-11 transition-colors hover:text-n-slate-12"
    :class="
      iconOnly
        ? 'size-8 shrink-0 items-center justify-center rounded-lg p-0 hover:bg-n-alpha-2 dark:hover:bg-n-alpha-3'
        : `p-0 ${buttonStyleClass}`
    "
    :aria-label="iconOnly ? $t('GENERAL_SETTINGS.BACK') : undefined"
    @click.capture="goBack"
  >
    <svg
      :width="iconOnly ? 22 : 20"
      :height="iconOnly ? 22 : 20"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="shrink-0"
      :class="iconOnly ? 'm-0' : '-ml-1'"
    >
      <path
        d="M13.75 4.75L7.5 11L13.75 17.25"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2.4"
      />
    </svg>
    <span v-if="!iconOnly" class="ms-0.5">{{
      buttonLabel || $t('GENERAL_SETTINGS.BACK')
    }}</span>
  </button>
</template>
